module.exports = __webpack_public_path__ + "naghmeh-social-icon--deezer.svg?c4ddb2fb18e93d4338896e8b29d0ed27";


//////////////////
// WEBPACK FOOTER
// ./src/assets/social-icons-edited/naghmeh-social-icon--deezer.svg
// module id = 211
// module chunks = 0